<template>
  <div class="app-layout">
    <header class="app-header">
      <div class="logo">
        <span class="mint">Mint</span><span class="vision">Vision</span>
      </div>
      <nav>
        <!-- <a href="#" class="active">Viewer</a>
        <a href="#">Projects</a>
        <a href="#">Settings</a> -->
      </nav>
      <!-- <div class="user-profile">
        <div class="avatar">U</div>
      </div> -->
    </header>

    <main class="app-main">
      <div class="viewer-wrapper">
        <ClientOnly>
          <SpeckleViewer />
          <template #fallback>
            <div class="loading-state">
              <div class="spinner"></div>
              <p>Initializing WebGL Engine...</p>
            </div>
          </template>
        </ClientOnly>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import SpeckleViewer from '~/components/SpeckleViewer.vue'
</script>

<style>
/* Global Resets & Base Variables */
:root {
  --bg-color: #0d0d12;
  --panel-bg: #16161d;
  --text-primary: #f0f0f5;
  --text-secondary: #8f8f9d;
  --accent-color: #00c8cb;
  --accent-hover: #008789;
  --border-color: rgba(255, 255, 255, 0.08);
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  background-color: var(--bg-color);
  color: var(--text-primary);
  overflow: hidden;
}

#__nuxt {
  height: 100%;
}

.text-muted {
  color: var(--text-secondary);
  font-size: 0.85rem;
  margin-bottom: 1.5rem;
}

/* App Layout */
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* Header */
.app-header {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background-color: var(--panel-bg);
  border-bottom: 1px solid var(--border-color);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.logo {
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: -0.5px;
}

.mint {
  color: var(--accent-color);
}

.vision {
  color: var(--text-primary);
}

nav {
  display: flex;
  gap: 32px;
}

nav a {
  color: var(--text-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: color 0.2s;
  padding: 8px 0;
}

nav a:hover {
  color: var(--text-primary);
}

nav a.active {
  color: var(--text-primary);
  border-bottom: 2px solid var(--accent-color);
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00c8cb, #8b5cf6);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
}

/* Main Content Area */
.app-main {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Viewer Wrapper */
.viewer-wrapper {
  flex: 1;
  background-color: var(--bg-color);
  position: relative;
}

/* Loading State for ClientOnly fallback */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text-secondary);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top-color: var(--accent-color);
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
